import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../store/slices/UI";
import Button from "../../../../UI/GeneralPurpose/Button";
import { contactEmailUI, detailsUI, requirementsUI, supportFocusUI } from "../Content/Content";

const UIText = {
  "es-CL": { label: "Borrar" },
  "en-US": { label: "Clear" },
};

const Clear = () => {
  const {auth,dispatch} = useUIBp();

  const onClick = () => {
    dispatch(UIactions.setField({ id: contactEmailUI, value: auth.user }));
    dispatch(UIactions.clear(requirementsUI));
    dispatch(UIactions.clear(supportFocusUI));
    dispatch(UIactions.clear(detailsUI));
  };

  return <Button {...{ UIText, onClick, variant: "text" }} />;
};

export default Clear;
